export default __webpack_public_path__ + "static/media/logoBg.3a5af555.svg";